/*
 * @Date: 2021-01-28 11:09:14
 * @LastEditors: 孙强强
 * @LastEditTime: 2021-09-15 17:11:02
 */
import { setNativeInfo, getSyncNativeInfo } from './untils'
const targetClass = 'com.kidswant.component.h5.HZWJsHandler'
/**
 * @description: 获取经纬度信息
 * @param {*} anGetlocation
 * @return {*}
 */
export const anGetlocation = () => {
  let loc = window.localjs && window.localjs.getkwgps()
  let rsp = {}
  switch (`${loc}`) {
    case '-2':
      rsp = {
        code: -2,
        msg: '未开启定位服务'
      }
      break
    case '-1':
      rsp = {
        code: -1,
        msg: '未开启定位权限'
      }
      break
    case '0':
      rsp = {
        code: 0,
        msg: '无定位结果'
      }
      break
    default:
      let res = loc && loc.split('_') || {}
      rsp = {
        code: 1,
        msg: 'success',
        data: {
          lat: res[0],
          lng: res[1],
        }
      }
  }
  return rsp
}
/**
 * @description: 设置页面标题
 * @param {*} anSetTitle
 * @return {*}
 */
export const anSetTitle = (title) => {
  setNativeInfo({
    methodName: 'hzwSetTitle_',
    parm: [{
      parmClass: 's',
      parmValue: title || ''
    }]
  })
}
/**
 * @description: 禁止和允许页面分享及刷新
 * @param {*} anRefreshOrShare
 * @return {*}
 */
export const anRefreshOrShare = ({ refresh = false, share = false } = {}) => {
  setNativeInfo({
    targetClass,
    methodName: 'controlFunction',
    parm: [{
      parmClass: 's',
      parmKey: 'canRefresh',
      parmValue: refresh ? '1' : '0'
    }, {
      parmClass: 's',
      parmKey: 'canShare',
      parmValue: share ? '1' : '0'
    }]
  })
}
/**
 * @description: 设置app右上角按钮
 * @param {*} anSetRightIcon
 * @return {*}
 */
export const anSetRightIcon = (buttons = []) => {
  let parms = []
  buttons.map((item, index) => {
    if (item.method) {
      item.method = `javascript:${item.method}`
    }
    parms.push({
      parmClass: 's',
      parmKey: `button${index}`,
      parmValue: item,
    })
  })
  setNativeInfo(
    {
      targetClass,
      methodName: 'controlRightAction',
      parm: parms,
    }
  )
}
/**
 * @description: 复制文本
 * @param {*} anCopyText
 * @return {*}
 */
export const anCopyText = (text) => {
  window.localjs.copyText(text)
}
/**
 * @description: 拉起小程序
 * @param {*} anOpenMin
 * @return {*}
 */
export const anOpenMin = ({ username = '', path = '', type = 0 } = {}) => {
  setNativeInfo(
    {
      targetClass,
      methodName: 'openMiniProgramWithUserName',
      parm: [
        {
          parmClass: 's',
          parmKey: 'page',
          parmValue: path,
        },
        {
          parmClass: 's',
          parmKey: 'userName',
          parmValue: username,
        },
        {
          parmClass: 's',
          parmKey: 'miniprogramType',
          parmValue: type,
        },
      ],
    }
  )
}
/**
 * @description: 拉起微信
 * @param {*} anOpenWx
 * @return {*}
 */
export const anOpenWx = () => {
  setNativeInfo(
    {
      targetClass,
      methodName: 'openWeiXin',
    }
  )
}
/**
 * @description: 获取刘海屏高度
 * @param {*} anGetHeaderHeight
 * @return {*}
 */
export const anGetHeaderHeight = () => {
  return getSyncNativeInfo(
    {
      targetClass,
      methodName: 'getNaviTypeConfig',
    }
  )
}
/**
 * @description: 拉起单个分享
 * @param {*} anSingleShare
 * @return {*}
 */
export const anSingleShare = (channel) => {
  setNativeInfo(
    {
      targetClass,
      methodName: 'invokeAppShare',
      parm: [
        {
          parmClass: 's',
          parmKey: 'channel',
          parmValue: channel,
        },
      ]
    }
  )
}
/**
 * @description: 设置标题栏样式
 * @param {*} anSetHeaderStyle
 * @return {*}
 */
export const anSetHeaderStyle = (value => {
  setNativeInfo(
    {
      targetClass,
      methodName: 'setChannelConfig',
      methodArgsTypes: 't,b',
      parm: [{
        parmClass: 's',
        parmKey: 'content',
        parmValue: value
      }]
    }
  )
})

/**
 * @description: 隐藏app的返回按钮
 * @param {*} anSetBackBtnHide
 * @return {*}
 */
export const anSetBackBtnHide = (value => {
  setNativeInfo(
    {
      targetClass,
      methodName: 'setBackVisible',
      methodType :'1',
      methodArgsTypes: 't,b'
    }
  )
})

/**
 * @description: 检查是否开启 push 提醒
 * @param {*} anCheckPushSetting
 * @return {*}
 */
 export const anCheckPushSetting = (() => {
  return getSyncNativeInfo(
    {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'checkPushSetting',
      methodArgsTypes: 't,b'
    }
  )
})

/**
 * @description: 跳转 push 提醒权限设置
 * @param {*} anCheckPushSetting
 * @return {*}
 */
 export const anOpenPushSetting = (() => {
  return getSyncNativeInfo(
    {
      targetClass: 'com.kidswant.component.h5.HZWJsHandler',
      methodType: '0',
      methodName: 'openPushSetting',
      methodArgsTypes: 't,b'
    }
  )
})
